import axios from 'axios';
import { useQuery } from 'react-query';

import { LeaderboardStats } from '~/../api/common.types';

export const useGetRankingsTotalStats = ({ enabled }) => {
  return useQuery<LeaderboardStats, Error>(
    ['rankingsTotalStats'],
    async () => {
      const { data: totalStats } = await axios({
        url: '/api/rankings/totalStats',
        method: 'get',
      });
      return totalStats;
    },
    {
      enabled: enabled,
    }
  );
};
